import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import SmartLink from '../Common/SmartLink';
import PageSection from './PageSection';
import * as styles from './TicketThreeUpSection.module.scss';

const TicketThreeUpSection = ({ pageMeta }) => {
  return (
    <PageSection noPad slim fullBleed data-analytics-section={'ticket-three-up'}>
      <div className={styles.mainContainer}>
        <div>
          <h3 className={styles.heading}>{pageMeta.heading}</h3>
        </div>
        <div className={styles.CardsContainer}>
          {pageMeta.content.map((card, idx) => (
            <div
              data-analytics-component={'ticket-three-up-card'}
              data-analytics-id={card.title}
              className={
                idx === 0
                  ? `${styles.mostPopularCardDesign} ${styles.singleCard}`
                  : idx === 1
                  ? `${styles.middleCardDesign} ${styles.singleCard}`
                  : `${styles.lastCardDesign} ${styles.singleCard}`
              }
            >
              <div className={styles.cardContentWrapper}>
                {idx === 0 && <div className={styles.mostPopular}>MOST POPULAR</div>}
                <h3 className={styles.CardTitle}>{card.title}</h3>
                <h2 className={styles.pricing}>{card.subtitle}</h2>
                <RichTextConverter copy={card.body} className={styles.cardInfo} />
                <div className={styles.linkContainer}>
                  <SmartLink to={card.linkUrl} className={styles.purchaseButton}>
                    {card.linkLabel}
                  </SmartLink>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {pageMeta?.ctaUrl && (
        <ArrowLink className={styles.freeCta} label={get(pageMeta, 'ctaLabel')} url={get(pageMeta, 'ctaUrl')} />
      )}
    </PageSection>
  );
};

TicketThreeUpSection.propTypes = {
  pageMeta: PropTypes.object,
};

export default TicketThreeUpSection;
